<template>
  <div class="content">
    <transition mode="out-in">
      <div v-if="currentPage == 'loading'" key="loading" class="l-loading">
        loading...
      </div>

      <div v-else-if="currentPage == 'test'" key="test" class="l-test">

        <transition mode="out-in">
          <div class="l-test__inner" v-bind:key="currentIndex">
            <div class="l-question">
              <QuestionText v-bind:test-type="testType" v-bind:test-id="testId"  v-bind:title="title" v-bind:question-id="currentQuestion.id"  v-bind:question-num="questionNum" v-bind:question-text="currentQuestion.questionText" v-bind:question-image="currentQuestion.questionImage" />
            </div>
            <div class="l-time-bar">
              <Timebar v-bind:timer-max="currentQuestion.timer"  v-bind:timer-stop="timerStop" v-bind:timer-init-start="timerInitStart" v-on:check-answer="checkAnswer" />
            </div>
            <div class="l-answer">
              <template v-if="currentQuestion.answerType == 'yesno'">
                <AnswerYesNo v-bind:correct-id="currentQuestion.correctId" v-on:check-answer="checkAnswer" />
              </template>
              <template v-if="currentQuestion.answerType == 'choice'">
                <AnswerChoices v-bind:choices="currentQuestion.choices"  v-bind:correct-id="currentQuestion.correctId" v-on:check-answer="checkAnswer" />
              </template>
            </div>

            <transition mode="out-in">
              <div v-if="isShowAnswerResult" v-on:click="nextQuestion" class="l-ansewr-result">
                <div class="l-ansewr-result__inner">
                  <template v-if="isAnswerResultOK">
                    <img :src="`${staticPath}img/factory/test/result_test_ok.png`">
                  </template>
                  <template v-else>
                    <img :src="`${staticPath}img/factory/test/result_test_ng.png`">
                  </template>
                </div>
              </div>
            </transition>
          </div>
        </transition>

      </div>

      <div v-else-if="currentPage == 'result'" key="result" class="l-result">
        <Result  v-bind:test-type="testType" v-bind:test-id="testId" v-bind:result-answer="resultAnswer" v-bind:title="title" v-bind:questions="questions" v-on:goto-present="gotoPresent" v-on:goto-self-menu="gotoSelfMenu"  v-on:goto-factory="gotoFactory" />
      </div>
      
      <div v-else-if="currentPage == 'present'" key="present" class="l-present">
        <Present v-bind:test-type="testType" v-bind:test-id="testId" v-on:goto-factory="gotoFactory" />
      </div>
      
      <div v-else key="error" class="l-error">
        Error!!
    </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .content {
    width: 100%;
    height: 100%;
    width: 100vw;
    height: 100vh;
    max-width: $max-page-width;
    max-height: $max-page-height;
  }

  .l-loading,
  .l-error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
  }

  .l-test,
  .l-result,
  .l-present  {
    position: relative;
    padding: 30px 20px;
    width: 100%;
    height: 100%;
  }

  .l-ansewr-result {
    position: absolute;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    max-width: $max-page-width;
    max-height: $max-page-height;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
  }

  .l-ansewr-result__inner {
    position: absolute;
    z-index: 1002;
    width: 70vw;
    height: 70vw;
    max-width: 300px;
    max-height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .v-enter-active, .v-leave-active {
    transition: opacity 0.5s;
  }

  .v-enter, .v-leave-to {
    opacity: 0;
  }
</style>

<script>
  import Constant from '@/constant';
  import api from '@/api';
  import QuestionText from '@/components/Study/Parts/QuestionText';
  import Timebar from '@/components/Study/Parts/Timebar';
  import AnswerChoices from '@/components/Study/Parts/AnswerChoices';
  import AnswerYesNo from '@/components/Study/Parts/AnswerYesNo';
  import Result from '@/components/Study/Parts/Result';
  import Present from '@/components/Study/Parts/Present';

  export default {
    name: 'TestContent',
    props: ['testType', 'testId'],

    components: {
      QuestionText,
      Timebar,
      AnswerChoices,
      AnswerYesNo,
      Result,
      Present
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,
        currentPage: 'loading',  // loading / test / result / present
        title: '',
        questions: '',
        currentIndex: 0,
        resultAnswer: [], // true=正解 false=不正解
        isShowAnswerResult: false,  // 設問1つの結果を表示
        isAnswerResultOK: false,  // 設問1つの結果正解不正解
        timerInitStart: false, // タイマーを初期化してスタート
        timerStop: false // タイマーを止めるか
      }
    },

    created() {

      // 設問データ取得
      const data_path = this.staticPath + 'data/';
      let data_src = '';

      if (this.testType == 'study') {

        data_src = data_path + 'study_' + this.testId + '.json';

      } else if (this.testType == 'exam') {

        data_src = data_path + 'exam_' + this.testId + '.json';
      }

      const prom = api.requestGet(data_src);

      prom.then( ( res ) => {

        const data = res.data;

        if (data) {

          this.title = data.title;

          this.questions = data.questions;

          this.currentPage = 'test';

        } else {
          this.currentPage = 'error';
        }
        
      })
      .catch( ( err ) => {
    
        this.currentPage = 'error';
        
      });

    },

    computed: {

      questionNum() {

        if (this.questions && this.questions.length > 0) {
          return this.questions.length;
        }
      },

      currentQuestion() {

        if (this.questions && this.questions.length > 0) {
          return this.questions[this.currentIndex];
        }
      }
    },

    methods: {

      // 設問1つの正解不正解
      checkAnswer(answer_result) {

        if (answer_result) {
          // 正解
          this.isAnswerResultOK = true;

          // 結果に入れる
          this.resultAnswer[this.currentIndex] = true;

        } else {
          // 不正解
          this.isAnswerResultOK = false;
          this.resultAnswer[this.currentIndex] = false;
        }

        // 結果表示
        this.isShowAnswerResult = true;

        // タイマーストップ
        this.timerStop = true;
        this.timerInitStart = false;
      },

      // 次の設問へ
      nextQuestion() {

        // 結果非表示
        this.isShowAnswerResult = false;

        if (this.currentIndex >= (this.questionNum - 1)) {
          // 最後の設問

          // 結果表示へ
          this.currentPage = 'result';
        
        } else {

          this.currentIndex++;

          // タイマー初期化
          this.timerStop = false;
          this.timerInitStart = true;
        }
      },
      
      gotoPresent() {
        this.currentPage = 'present';
      },

      gotoSelfMenu() {
        this.$emit('goto-self-menu', this.testType);
      },

      gotoFactory() {
        this.$emit('goto-factory');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/TestContent.vue